import { PK, SelectOption } from 'common/types';
import { ContentGoal } from './types';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'modules/auth/consts';
import { authStore } from 'common/hooks/useAuthStore';

export const transformContentGoals = (goals: ContentGoal[]): SelectOption<PK>[] =>
  goals.map((goal) => ({
    label: goal.label,
    value: goal.pk,
  }));

export type Flatten<T> = T extends Record<string, infer V> ? Flatten<V> : T;

export const clearAuthState = () => {
  Cookies.remove(ACCESS_TOKEN);
  Cookies.remove(REFRESH_TOKEN);
  authStore.getState().invalid();
};
